import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, redirectTo = '/', isLoggedIn, ...rest }) => (
  // Show the component only when the user is logged in
  // Otherwise, redirect the user to /signin page

  <Route
    {...rest}
    render={props =>
      isLoggedIn ? (
        <Component {...props} redirectTo={`admin/${String(redirectTo).replace('admin/', '').replace('/', '')}`} />
      ) : (
        <Redirect to="/" />
      )
    }
  />
);

export default PrivateRoute;
